/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as FleetRouteImport } from './routes/fleet'
import { Route as CostsRouteImport } from './routes/costs'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CConversationIdRouteImport } from './routes/c.$conversationId'

const FleetRoute = FleetRouteImport.update({
  id: '/fleet',
  path: '/fleet',
  getParentRoute: () => rootRouteImport,
} as any)
const CostsRoute = CostsRouteImport.update({
  id: '/costs',
  path: '/costs',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CConversationIdRoute = CConversationIdRouteImport.update({
  id: '/c/$conversationId',
  path: '/c/$conversationId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/costs': typeof CostsRoute
  '/fleet': typeof FleetRoute
  '/c/$conversationId': typeof CConversationIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/costs': typeof CostsRoute
  '/fleet': typeof FleetRoute
  '/c/$conversationId': typeof CConversationIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/costs': typeof CostsRoute
  '/fleet': typeof FleetRoute
  '/c/$conversationId': typeof CConversationIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/costs' | '/fleet' | '/c/$conversationId'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/costs' | '/fleet' | '/c/$conversationId'
  id: '__root__' | '/' | '/costs' | '/fleet' | '/c/$conversationId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CostsRoute: typeof CostsRoute
  FleetRoute: typeof FleetRoute
  CConversationIdRoute: typeof CConversationIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/fleet': {
      id: '/fleet'
      path: '/fleet'
      fullPath: '/fleet'
      preLoaderRoute: typeof FleetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/costs': {
      id: '/costs'
      path: '/costs'
      fullPath: '/costs'
      preLoaderRoute: typeof CostsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$conversationId': {
      id: '/c/$conversationId'
      path: '/c/$conversationId'
      fullPath: '/c/$conversationId'
      preLoaderRoute: typeof CConversationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CostsRoute: CostsRoute,
  FleetRoute: FleetRoute,
  CConversationIdRoute: CConversationIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
